/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Secondtelefone1Inputs */

const de__field_secondtelefone1 = /** @type {(inputs: _Field_Secondtelefone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zweite Telefonnummer (privat)`)
};

/**

* @param {_Field_Secondtelefone1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_secondtelefone1 = /** @type {((inputs?: _Field_Secondtelefone1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Secondtelefone1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_secondtelefone1(inputs)
});
export { _field_secondtelefone1 as "_field_secondTelefone" }